/**
 * Local read contract for expense invoice lookup within BankDocuments feature.
 * Isolates BankDocuments UI from upstream ExpenseInvoices DTO changes.
 */
export interface BankDocumentExpenseInvoiceLookup {
  id: number;
  invoiceNumber: string;
  supplierName: string;
  totalGross: number;
  currency: string;
  statusLabel: string;
}

export interface BankDocumentExpenseInvoiceLookupSource {
  id: number;
  invoiceNumber?: string | null;
  supplierName?: string | null;
  documentReference?: string | null;
  displayIssuerName?: string | null;
  totalGross: number;
  currency: string;
  status: string;
}

const EXPENSE_INVOICE_STATUS_LABELS: Record<string, string> = {
  draft: 'Szkic',
  received: 'Otrzymana',
  verified: 'Zweryfikowana',
  paid: 'Opłacona',
  cancelled: 'Anulowana',
};

const getBankDocumentExpenseInvoiceStatusLabel = (status: string): string => {
  if (Object.prototype.hasOwnProperty.call(EXPENSE_INVOICE_STATUS_LABELS, status)) {
    return EXPENSE_INVOICE_STATUS_LABELS[status];
  }

  return status;
};

export const mapExpenseInvoiceToBankDocumentLookup = (
  expenseInvoice: BankDocumentExpenseInvoiceLookupSource | undefined | null
): BankDocumentExpenseInvoiceLookup | undefined => {
  if (!expenseInvoice) {
    return undefined;
  }

  return {
    id: expenseInvoice.id,
    invoiceNumber: expenseInvoice.invoiceNumber ?? expenseInvoice.documentReference ?? `#${expenseInvoice.id}`,
    supplierName: expenseInvoice.supplierName ?? expenseInvoice.displayIssuerName ?? 'Koszt uproszczony',
    totalGross: expenseInvoice.totalGross,
    currency: expenseInvoice.currency,
    statusLabel: getBankDocumentExpenseInvoiceStatusLabel(expenseInvoice.status),
  };
};
